import ResetPasswordForm from "../../../components/auth/ResetPasswordForm";

const ResetPassword = () => {
	return (
		<>
			<div className="text-center">
				<h5>Reset new password</h5>
				<ResetPasswordForm />
			</div>
		</>
	);
};

export default ResetPassword;
